import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateLocationTypeRequest extends BaseUpdateRequest {
    name = '';
}